<div
	#diagramContainer
	class="container stages-expand-collapse-from-top"
	[class.stages-expanded]="expanded"
	[class.stages-collapsed]="!expanded"
>
	<div class="stages-expand-collapse-content">
	@if (imageZoomToolLoaded && currentElement) {
		<stages-image-zoom
			#imgZoom
			[sourceChanged]="sourceChanged"
			[diagramLoaded]="diagramLoaded!"
			[isFirstDiagram]="isFirstDiagramOnPage"
			[isZoomToolSupported]="isBrowserSupported"
			[id]="diagramId!"
			[fitToPage]="fitToPage"
			[prefixedIdent]="config.prefixedIdent"
			[currentElementName]="currentElement.label"
			[imageMap]="imageMap"
			[src]="src!"
			[container]="diagramContainer"
		></stages-image-zoom>
	}
	@if (expanded && (!imageZoomToolLoaded || !currentElement || refreshingDiagram)) {
		<div style="height: 30px">
			<stages-spin size="sm"></stages-spin>
		</div>
	}
	</div>
</div>
